import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { CustomSpinner } from '_atoms';

// custom modal used for displaying alert messages
const CustomModal = (props) => {
 
    return (
        <Modal show={props.show} onHide={props.close}>

            {/* Header */}
            <Modal.Header closeButton>
                <Modal.Title>{props.title}</Modal.Title>
            </Modal.Header>

            {/* Body */}
            <Modal.Body>{props.body}</Modal.Body>
            <Modal.Body>{props.subbody}</Modal.Body>

            {props.bodyComponent && props.bodyComponent}

            {/* Footer */}
            <Modal.Footer>
                {/* Other prop Button */}
                <Button variant={props.buttonVariant ? props.buttonVariant : "primary"} onClick={props.openButton}>
                    {
                        props.loading && props.loading == true ?
                        <CustomSpinner />
                        :
                        props.button
                    }

                   
                </Button>           

            </Modal.Footer>

        </Modal>
    );
};


export default CustomModal;
